// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"cd7f50e6","96":"e306e6e1","195":"c3bc4e21","252":"153ec2fa"}[chunkId] + ".chunk.js";
};